import { Environment } from "./environment";

export const tooShareConfig = {
	aboutUrl: "https://about.tooshare.com",
	feedbackUrl: "https://feedback.tooshare.com",
	supportEmail: "support@tooshare.com",
	features: {
		professionalExperiences: true,
		login: {
			facebook: true,
			apple: true,
			phone: true,
		},
		classrooms: {
			enablePremium: true,
			enableLive: true,
		},
		profile: {
			messaging: true,
		},
		messaging: {
			showInTopBar: true,
		},
		guestRender: false,
		facebookSharing: true,
		shareRooms: true,
		enableRegisterFollowSuggestions: true,
		banner: true,
		program: false,
		coursesExternalProviders: true,
	},
};

export const jaangalConfig = {
	aboutUrl: "https://about.jaangal.com",
	feedbackUrl: "https://feedback.jaangal.com",
	supportEmail: "support@jaangal.com",
	features: {
		professionalExperiences: false,
		login: {
			facebook: false,
			apple: false,
			phone: false,
		},
		classrooms: {
			enablePremium: false,
			enableLive: false,
		},
		profile: {
			messaging: true,
		},
		messaging: {
			showInTopBar: true,
		},
		guestRender: false,
		facebookSharing: true,
		shareRooms: true,
		enableRegisterFollowSuggestions: true,
		banner: false,
		program: false,
		coursesExternalProviders: false,
	},
};

export const config = Environment.APP_VARIANT === "jaangal" ? jaangalConfig : tooShareConfig;
